import { render, staticRenderFns } from "./lifetime-changer.vue?vue&type=template&id=3f2d4467&"
import script from "./lifetime-changer.vue?vue&type=script&lang=ts&"
export * from "./lifetime-changer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports